import * as React from 'react'

import { CmsPage, RenderCmsComponent } from 'bloomreach-experience-react-sdk'
import getConfig from 'next/config'

import { WebPage } from '@grandvision/analytics'
import { DefaultPageProps, QueryParams } from '@grandvision/bloomreach'
import { useIntl } from '@grandvision/state'

import componentDefinitions from '../cms/component-definitions'
import Layout from '../components/Layout'

const { publicRuntimeConfig } = getConfig()
const appointmentUrl = publicRuntimeConfig.grandvision.appointmentUrl || ''
const selfUrl = publicRuntimeConfig.selfUrl || ''
const siteName = publicRuntimeConfig.site.name || ''

type Props = DefaultPageProps & {
  search: QueryParams
}

const AppointmentPage = ({ pageModel, asPath, request, search }: Props) => {
  if (!pageModel) {
    console.error('No page model defined for appointment page!')
    return null
  }
  const { getLabel } = useIntl()
  const { storeId, postalCode } = search
  const paramObject = { shop: storeId || '', postnr: postalCode || '', search: true }
  const params = Object.entries(paramObject)
    .map(([key, val]) => `${key}=${val}`)
    .join('&')

  if (!appointmentUrl) {
    console.error('No valid appointmentUrl supplied!')
  }

  return (
    <CmsPage
      cmsUrls={publicRuntimeConfig.bloomreach.cmsUrls}
      pageModel={pageModel}
      request={request}
      componentDefinitions={componentDefinitions}
    >
      {() => (
        <Layout
          asPath={asPath}
          isSolaris={false}
          pageModel={pageModel}
          renderFooter={false}
          renderSiteNav={true}
        >
          <RenderCmsComponent path="main/top-container" />

          <div className="site-container appointment">
            {appointmentUrl && (
              <iframe
                className="appointment__iframe"
                frameBorder="0"
                marginHeight={0}
                marginWidth={0}
                scrolling="false"
                src={encodeURI(`${appointmentUrl}${params ? '?' + params : ''}`)}
              />
            )}
          </div>

          <RenderCmsComponent path="main/bottom-container" />

          <WebPage
            url={selfUrl + asPath}
            pageType="AppointmentFunnel"
            name={`${getLabel('appointment.booking.page.title')} | ${siteName}`}
          />
        </Layout>
      )}
    </CmsPage>
  )
}

AppointmentPage.getInitialProps = async ({ asPath, query }) => {
  const { pageModel, request, search, preview } = query as any

  return {
    asPath,
    pageModel,
    preview,
    request,
    search,
  }
}

export default AppointmentPage
